import { applyDiscountVoucher } from "@/services/core-api-adapter";
import { useGlobalStore } from "@/store";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

export default function useApplyDiscountVoucher() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const { state } = useGlobalStore();
  const memberId = state.currentUser.memberId;
  const queryClient = useQueryClient();

  const applyVoucher = async (voucherCode: string) => {
    try {
      setIsLoading(true);
      setError(null);
      const result = await applyDiscountVoucher(voucherCode, memberId);
      queryClient.invalidateQueries({
        queryKey: ["getMemberDiscountVouchers"],
      });
      return result;
    } catch (err) {
      setError((err as Error) || new Error("Something went wrong"));
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    applyVoucher,
    isLoading,
    error,
    isError: !!error,
    resetError: () => setError(null),
  };
}
